import { Link } from "react-router-dom";

/**
 * Simple redirect utility for sign in/out flows
 * Let the ProtectedRoute component handle route protection logic
 */

/**
 * Store the current location before navigating to sign-in
 * This allows us to redirect back after successful sign-in
 * @param {string} currentPath - The current route path
 */
export const prepareSignInRedirect = (currentPath) => {
  // Only store if we're not already on signin and it's not a protected route
  if (currentPath !== "/signin") {
    sessionStorage.setItem("signInDestination", currentPath);
  }
};

/**
 * Custom Link component that automatically stores current location before navigating to sign-in
 * Use this instead of regular Link when linking to /signin
 */
export const SignInLink = ({ to, children, ...props }) => {
  const handleClick = () => {
    // Store current location before navigating
    const currentPath = window.location.pathname;
    prepareSignInRedirect(currentPath);
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};

/**
 * Get the appropriate redirect destination for sign in/out
 * @param {string} currentPath - The current route path
 * @returns {string} - The redirect destination
 */
export const getRedirectDestination = (currentPath) => {
  // If on a tournament route, redirect to tournament overview
  if (currentPath.startsWith("/tournament/")) {
    const tournamentMatch = currentPath.match(/^\/tournament\/([^\/]+)/);
    if (tournamentMatch) {
      return `/tournament/${tournamentMatch[1]}`;
    }
  }

  // For all other routes, redirect to home
  return "/";
};

/**
 * Simple redirect behavior - let ProtectedRoute handle the complexity
 * @param {string} currentPath - The current route path
 * @returns {Object} - Redirect behavior object
 */
export const getRedirectBehavior = (currentPath) => {
  // Always redirect on sign out for consistency
  // Let ProtectedRoute handle whether the route actually needs protection
  return {
    shouldRedirect: true,
    reason: "sign_out",
    destination: getRedirectDestination(currentPath),
  };
};
